<template>
  <div class="map-wrapper">
    <div class="map-embed-box">
      <iframe :src="embedUrl" class="map-embed-canvas" />
    </div>
    <p class="btn-wrapper">
      <a
        :href="gmapUrl"
        :class="{ btn: $device.isMobile }"
        @click="
          handleAnalyticsTrackEvent('facility_detail', 'click', 'map_link', 1)
        "
        target="_blank"
        class="to-index"
        >大きな地図で見る</a
      ><template v-if="!$device.isMobile">&gt;&gt;</template>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    lat: {
      type: Number,
      required: true
    },
    lng: {
      type: Number,
      required: true
    },
    zoom: {
      type: String,
      default: ''
    },
    placeName: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    placeId: {
      type: String,
      default: ''
    }
  },
  computed: {
    googleMapApiKey() {
      return process.env.GOOGLE_MAPS_API_KEY
    },
    embedUrl() {
      const url =
        'https://www.google.com/maps/embed/v1/place?zoom=' +
        this.zoom +
        '&key=' +
        this.googleMapApiKey

      if (this.placeId) {
        return url + '&q=place_id:' + this.placeId
      } else {
        return url + '&q=' + encodeURIComponent(this.lat + ',' + this.lng)
      }
    },
    gmapUrl() {
      const placeName = this.placeName.replace(/\(/g, '（').replace(/\)/g, '）')
      const address = this.address.replace(/\(/g, '（').replace(/\)/g, '）')

      const url = 'https://www.google.com/maps/search/?api=1&query='
      if (this.placeId) {
        return (
          url +
          encodeURIComponent(placeName + ',' + address) +
          '&q=query_place_id=' +
          this.placeId
        )
      } else {
        return url + encodeURIComponent(this.lat + ',' + this.lng)
      }
    }
  }
}
</script>
